import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/_modules/auth/services/auth.service';
import { Profile } from '@app/definitions/interfaces';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {
    isProfile = true;
    profile: Profile;

    constructor(private authService: AuthService, private router: Router) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.profile = JSON.parse(localStorage.getItem('profile'));
            if (!this.profile) {
                this.isProfile = false;
            }
            if (this.profile) {
                this.checkUserInfo();
            }
        }, 1000);
    }

    checkUserInfo(): void {
        const isEmptyUserInfo = this.authService.checkUserInfo(this.profile);

        if (isEmptyUserInfo) {
            this.router.navigate(['profile', 'data']);
            return;
        }
        this.router.navigate(['profile', 'notifications']);
    }
}
